(function () {
  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function bindScroller(root) {
    var viewport = root.querySelector('[data-mn-looks-viewport]');
    var grid = root.querySelector('[data-mn-looks-grid]');
    var prev = root.querySelector('[data-mn-looks-prev]');
    var next = root.querySelector('[data-mn-looks-next]');
    var hint = root.querySelector('[data-mn-looks-hint]');

    if (!viewport || !grid || !prev || !next) return;

    function cardsPerPage() {
      if (window.innerWidth >= 1024) return 4;
      if (window.innerWidth >= 768) return 2;
      return 1;
    }

    function buildPages() {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.mn-looks__card'));
      if (!cards.length) return;

      var existingPages = Array.prototype.slice.call(grid.querySelectorAll('.mn-looks__page'));
      if (existingPages.length) {
        cards = [];
        existingPages.forEach(function (page) {
          Array.prototype.slice.call(page.children).forEach(function (card) {
            cards.push(card);
          });
        });
      }

      grid.innerHTML = '';
      var perPage = cardsPerPage();
      for (var i = 0; i < cards.length; i += perPage) {
        var page = document.createElement('div');
        page.className = 'mn-looks__page';
        if (window.innerWidth < 1024) page.classList.add('is-mobile');
        cards.slice(i, i + perPage).forEach(function (card) {
          page.appendChild(card);
        });
        grid.appendChild(page);
      }
    }

    function stepSize() {
      return viewport.clientWidth;
    }

    function updateNav() {
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      prev.disabled = viewport.scrollLeft <= 4;
      next.disabled = viewport.scrollLeft >= maxScroll - 4;

      if (hint) {
        hint.textContent = window.innerWidth <= 767 ? 'Swipe to see more videos' : 'Scroll to see more videos';
      }
    }

    prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      viewport.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateNav, { passive: true });
    var lastMode = cardsPerPage();
    window.addEventListener('resize', function () {
      var nextMode = cardsPerPage();
      if (nextMode !== lastMode) {
        buildPages();
        lastMode = nextMode;
        viewport.scrollLeft = 0;
      }
      updateNav();
    });

    buildPages();
    updateNav();
  }

  function bindLooks(root) {
    var cards = root.querySelectorAll('[data-mn-look]');
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      playVideo(video);
      video.addEventListener('canplay', function () {
        card.classList.add('is-playing');
        playVideo(video);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) playVideo(video);
            else video.pause();
          });
        },
        { threshold: 0.25 }
      );
      cards.forEach(function (card) {
        if (card.querySelector('video')) io.observe(card);
      });
    }

    bindScroller(root);
  }

  document.querySelectorAll('[data-mn-looks]').forEach(bindLooks);

  document.addEventListener(
    'touchstart',
    function once() {
      document.querySelectorAll('[data-mn-looks] video').forEach(playVideo);
    },
    { once: true, passive: true }
  );
})();
